<template>
  <div>
    <navbar>
      <template slot="left-menu"><left-menu-container/></template>
      <template slot="right-menu"><right-menu-container/></template>
      <template slot="hamburger">
        <hamburger :is-active="isMenuOpen" @click="toggleMenu"/>
      </template>
    </navbar>
    <sidebar @click="hideMenu" :is-active="isMenuOpen">
      <left-menu-container/>
      <right-menu-container/>
      <theme-switcher-container/>
    </sidebar>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { TOGGLE_MENU } from '@/store/mutation-types'
import Navbar from '@/containers/Navigation/Navbar'
import LeftMenuContainer from '@/containers/Navigation/LeftMenuContainer'
import RightMenuContainer from '@/containers/Navigation/RightMenuContainer'
import Hamburger from '@/containers/Navigation/Hamburger'
import Sidebar from '@/containers/Navigation/Sidebar'
import ThemeSwitcherContainer from '@/containers/Navigation/ThemeSwitcherContainer'

export default {
  components: {
    Navbar,
    LeftMenuContainer,
    RightMenuContainer,
    Hamburger,
    Sidebar,
    ThemeSwitcherContainer
  },
  computed: {
    ...mapState({ isMenuOpen: state => state.nav.isMenuOpen })
  },
  methods: {
    ...mapMutations({ toggleMenu: TOGGLE_MENU }),
    hideMenu (evt) {
      if (evt.target.nodeName.toLowerCase() === 'a') this.toggleMenu()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Navigation/NavigationContainer.vue